import { TextField } from "../shared-ui";
import { getAtPath, setAtPath } from "../path-utils";
import { str, type PanelProps } from "../shared";

export function ClosingPanel({ root, disabled, onChangeRoot }: PanelProps) {
  const statement = str(getAtPath(root, "game.closing.statement"));
  const truth = str(getAtPath(root, "game.closing.truth_review"));

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-muted-foreground">
        全部谜题解开后的收尾文案。真相复盘可使用 Markdown。
      </p>
      <TextField
        label="结案陈述"
        value={statement}
        disabled={disabled}
        multiline
        rows={4}
        onChange={(v) =>
          onChangeRoot(setAtPath(root, "game.closing.statement", v))
        }
      />
      <TextField
        label="真相复盘"
        value={truth}
        disabled={disabled}
        multiline
        rows={10}
        onChange={(v) =>
          onChangeRoot(setAtPath(root, "game.closing.truth_review", v))
        }
      />
    </div>
  );
}
